import type { AllRouteEndpoints } from "../routeTypes";

export const engagementReportBuilder2AppGroupIdReportId = "/engagement/report_builder_2/:report_id/:app_group_id";
export const engagementReportBuilder2AppGroupIdReportIdCacheKeys: AllRouteEndpoints[] = [
  "/engagement/report_builder_2/:report_id/:app_group_id",
];
